import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { MediaHitsContextValue } from './types';

/** @knip-ignore */
export const {
	Context: MediaHitsContext,
	Provider: MediaHitsContextBaseProvider,
	useContext: useMediaHitsContext,
} = createMandatoryContext<MediaHitsContextValue>(undefined, {
	name: 'MediaHitsContext',
});
